import React, { useEffect, useState, useContext } from "react";
import AuthContext from "../../contexts/AuthContext";
import ApiCall from "../../utils/ApiCall";
import { USERDATA } from "../../Constants";
import { Loader, Table } from "../../components";

const EmployeeDatabase = () => {
  const { authTokens } = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("active");

  // ✅ SAME AS MODIFY USER
  const [currentPage, setCurrentPage] = useState(1);
  const rowPerPage = 7;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await ApiCall(USERDATA, "GET", authTokens, null);
      setUsers(res.data || []);
      setIsLoading(false);
    } catch (error) {
      console.log("Error fetching user data", error);
      setIsLoading(false);
    }
  };

  // 🔹 Filter Active / Inactive
  const filteredByStatus = users.filter((user) =>
    activeTab === "active" ? user.is_active : !user.is_active
  );

  // 🔹 Search Filter
  const filteredUsers = filteredByStatus.filter((user) =>
    user.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ✅ SAME PAGINATION HANDLER
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="w-auto my-6 flex flex-col mx-6 py-4 px-2">
      <h2 className="text-lg font-semibold mb-4 text-white">
        Employee Database
      </h2>

      {/* 🔹 Tabs */}
      <div className="flex justify-between items-center px-2 pb-3 border-b border-gray-600 mb-6">

  {/* 🔹 Tabs (Left) */}
  <div className="flex gap-6">
    <button
      onClick={() => {
        setActiveTab("active");
        setCurrentPage(1);
      }}
      className={`pb-2 text-sm font-medium ${
        activeTab === "active"
          ? "text-blue-400 border-b-2 border-blue-400"
          : "text-gray-400 hover:text-white"
      }`}
    >
      Active Employees
    </button>

    <button
      onClick={() => {
        setActiveTab("inactive");
        setCurrentPage(1);
      }}
      className={`pb-2 text-sm font-medium ${
        activeTab === "inactive"
          ? "text-blue-400 border-b-2 border-blue-400"
          : "text-gray-400 hover:text-white"
      }`}
    >
      Inactive Employees
    </button>
  </div>

  {/* 🔹 Search (Right - SAME ROW) */}
  <input
    type="text"
    placeholder="Search by name..."
    className="px-4 py-2 rounded-lg bg-transparent border border-gray-500 text-white outline-none w-64"
    value={searchTerm}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(1);
    }}
  />
</div>
    

      {/* 🔹 Search */}
      

      {/* 🔹 Table */}
      {isLoading ? (
        <div className="w-full h-[60vh] flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <Table
          header={[
            "Employee ID",
            "Employee Name",
            "Role",
            "DOJ",
            "Report To",
          ]}
          body={filteredUsers.map((row) => [
            row.employee_id || "-",
            row.name || "-",
            row.role || "-",
            row.doj || "-",
            row.report_to || "-",
          ])}
          btnTitle="View"   // ✅ SAME AS MODIFY USER
          paginationNeed={true}   // ✅ IMPORTANT
          currentPage={currentPage}
          rowPerPage={rowPerPage}
          paginationBody={filteredUsers}  // ✅ IMPORTANT
          onPageChange={handlePageChange}
          onClick={() => {}}  // ✅ View button does nothing (as requested)
          tableStyle="intro-x"
        />
      )}
    </div>
  );
};

export default EmployeeDatabase;